import { Tooltip } from 'antd';
import React, { FC, useMemo } from 'react';
import { ReactComponent as SmartFill } from 'assets/svgs/smartfill.svg';
import { IconShell } from 'components/atoms/icon-shell';
import { RichTextEditor } from 'components/atoms/rich-text-editor';
import styles from 'components/organisms/templates/commons/cke.module.css';
import {
  ProjectTemplatePhaseData,
  useProjectTemplateProjectPhase,
} from 'data/templates/projects';
import { ProjectPhaseMoreActions } from '../../commons';
import { MoreActions, Status, TemplateIndicatorWrapper } from './styles';

export const RenderProjectPhaseName: FC<{
  record: ProjectTemplatePhaseData;
}> = ({ record }) => {
  const projectPhase = useProjectTemplateProjectPhase(record.id);

  const hasVariable = useMemo(
    () => projectPhase?.projectPhaseName.includes('class="simpleVariables"'),
    [projectPhase?.projectPhaseName],
  );

  if (!projectPhase) {
    return null;
  }

  return (
    <>
      <IconShell
        data-cy={`project-template-phase-status-${projectPhase.projectPhaseName}`}
        icon={
          <Status
            progress={0}
            status={{
              label: 'To do',
              group: 1,
              color: 'blue',
            }}
          />
        }
        size="middle"
      />
      {hasVariable && (
        <TemplateIndicatorWrapper>
          <Tooltip title="SmartFill">
            <SmartFill />
          </Tooltip>
        </TemplateIndicatorWrapper>
      )}
      <span
        data-cy={`project-template-phase-title-${projectPhase.projectPhaseName}`}
      >
        <RichTextEditor
          className={`${styles['template-title-input']} ${styles['template-list-view']}`}
          data={projectPhase.projectPhaseName}
          readonly
          allowSimpleVariables
          disallowNewLine
        />
      </span>
      <MoreActions
        data-cy={`project-template-phase-more-actions-${projectPhase.projectPhaseName}`}
        className="more__actions"
      >
        <ProjectPhaseMoreActions projectPhaseId={projectPhase.projectPhaseId} />
      </MoreActions>
    </>
  );
};
